import { render } from "./Form.vue?vue&type=template&id=9c75e2a8&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=9c75e2a8&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\beweegminuut\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c75e2a8"]])

export default __exports__